var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('EntityTable',{attrs:{"name":"Apps","headers":_vm.app_headers,"items":_vm.apps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }